<div class="standard-decorator">
  <app-layout-control>
    <app-control-label top [control]="control()" [caption]="caption()" [infoText]="infoText()" [forId]="inputId()"></app-control-label>
    <ng-content></ng-content>
    <app-control-supporting-text bottom [control]="control()" [controlName]="caption()" [isValid]="isValid" [calculateValidationText]="calculateValidationText()">
    </app-control-supporting-text>
  </app-layout-control>
</div>
